<script setup lang="ts">
// Disable SSR for customers page
definePageMeta({
  ssr: false
});

useHead({
  title: "Customers - Komunite"
});

// Fetch customer overview stats (includes Pareto)
const { data: stats } = useLazyFetch("/api/customers/overview");

// Fetch segment matrix
const { data: segmentMatrix } = useLazyFetch("/api/customers/segment-matrix");

// Format number
const formatNumber = (num: number) => {
  return new Intl.NumberFormat("tr-TR").format(num);
};
</script>

<template>
  <UDashboardPanel id="customers">
    <template #body>
      <div class="p-6 space-y-12">
        <!-- Overview Section -->
        <AppSection title="Overview">
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <CustomerStatsCard
              title="Total Customers"
              icon="i-lucide-users"
              :value="formatNumber(stats?.total_customers || 0)"
              description="All time customers"
            />

            <CustomerStatsCard
              title="Active Customers"
              icon="i-lucide-user-check"
              :value="formatNumber(stats?.active_30d || 0)"
              description="Active in last 30 days"
            />

            <CustomerStatsCard
              title="Pareto Principle"
              icon="i-lucide-trending-up"
              :value="`${stats?.pareto?.top_20?.percentage || 0}%`"
              :description="`Top 20% customers (${formatNumber(stats?.pareto?.top_20?.count || 0)}) generate ${stats?.pareto?.top_20?.percentage || 0}% of revenue`"
            />
          </div>
        </AppSection>

        <!-- Segment Matrix Section -->
        <AppSection title="Customer Segmentation Matrix">
          <CustomerSegmentMatrix
            v-if="segmentMatrix"
            :matrix="segmentMatrix.matrix"
            :grand-total="segmentMatrix.grandTotal"
          />
          <div v-else class="text-center py-8 text-gray-500 dark:text-gray-400">
            Loading matrix...
          </div>
        </AppSection>

      </div>
    </template>
  </UDashboardPanel>
</template>
